import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './ProductPrice.styled';
import { ProductPriceFragment } from './ProductPrice.gql';
import { formatPrice } from '../../../../util/localize';

/**
 * Displays the price of the product with any applicable discounts
 */
const ProductPrice = ({
  percentOff,
  originalPrice,
  discountPrice,
  discountCopy,
  currencyCode,
  ...props
}) => (
  <Styled.ProductPrice {...props}>
    <Styled.Price>
      {discountPrice && <Styled.Invisible>Now: </Styled.Invisible>}
      {formatPrice(discountPrice || originalPrice, currencyCode)}
    </Styled.Price>
    {discountPrice && (
      <Styled.Strikeout>
        <Styled.Invisible>Was: </Styled.Invisible>
        {formatPrice(originalPrice, currencyCode)}
      </Styled.Strikeout>
    )}
    {percentOff && (
      <Styled.Discount>
        {percentOff}% {props.hasMultipleItems ? discountCopy : 'Savings'}
      </Styled.Discount>
    )}
  </Styled.ProductPrice>
);

ProductPrice.propTypes = {
  /**
   * the amount of any potential discount
   */
  percentOff: PropTypes.number,
  /**
   * product price before any potential discount
   */
  originalPrice: PropTypes.string.isRequired,
  /**
   * discount price (optional)
   */
  discountPrice: PropTypes.string,
  /**
   * text description of the savings
   */
  discountCopy: PropTypes.string,
  /**
   * whether the product has multiple items
   */
  hasMultipleItems: PropTypes.bool,
  /**
   * currency code for formatting the price
   */
  currencyCode: PropTypes.string
};

ProductPrice.defaultProps = {
  percentOff: null,
  discountPrice: undefined,
  discountCopy: 'Pack Savings',
  hasMultipleItems: false
};

ProductPrice.fragment = ProductPriceFragment;

export default ProductPrice;
